import React from 'react'
import { makeStyles } from '@mui/styles'
import clsx from 'clsx'

type Props = {
  heading: string,
  body: string,
  className?: string
}

function RichTooltipContent(props: Props) {
  const classes = useStyles(props)

  return (
    <div className={clsx(classes.tooltip, props.className)}>
      {props.heading && <div className={classes.tooltipHeading}>{props.heading}</div>}
      {
        typeof props.body === 'string'
          ? <div className={classes.tooltipBody} dangerouslySetInnerHTML={{ __html: props.body }} />
          : <div className={classes.tooltipBody}>{props.body}</div>
      }

    </div>
  )
}

const useStyles = makeStyles((theme) => ({
  tooltip: {
    color: theme.textColor,
  },
  tooltipHeading: {
    fontSize: theme.fontSizes.default,
    fontWeight: theme.fontWeights.bold,
    marginBottom: 10,
  },
  tooltipBody: {
    fontSize: theme.fontSizes.smaller,
  },
}))

export default RichTooltipContent
